<template>
    <div class="text-center">
        <v-dialog
            v-model="show"
            width="unset"
            max-width="500"
            tabindex="-1"
            role="dialog"
            aria-labelledby="RequestAcceptModal"
            aria-hidden="true"
            transition="v-expand-y-transition"
        >
            <v-card
                class="elevation-12"
                max-width="500px"
                transition="v-expand-y-transition"
            >
                <v-toolbar
                    color="primary"
                    class="mb-6"
                    dark
                    flat
                >
                    <v-toolbar-title>Accept this request?</v-toolbar-title>
                </v-toolbar>
                <v-card-subtitle class="px-6 pb-6 pt-0 body-2">
                    Below are the details of the current request.
                    After you've verified the information is correct, click pay.
                </v-card-subtitle>

                <v-card-text class="px-6 pb-6 pt-0">
                    <v-row>
                        <v-col>
                            <p class="overline my-0">
                                <strong>Requestor information:</strong>
                            </p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <p class="overline my-0">
                                Name
                            </p>
                            <p class="body-1 my-0">
                                {{ requestor.firstname }} {{ requestor.lastname }}
                            </p>
                        </v-col>
                        <v-col>
                            <p class="overline my-0">
                                Address
                            </p>
                            <p class="body-1 my-0">
                                {{ requestor.street_number }} {{ requestor.address }}
                            </p>
                            <p class="body-1 my-0">
                                {{ requestor.city }}
                            </p>
                            <p class="body-1 my-0">
                                {{ requestor.zipcode }}
                            </p>
                            <p class="body-1 my-0">
                                {{ requestor.country }}
                            </p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <p class="overline my-0">
                                Phone number
                            </p>
                            <p class="body-1 my-0">
                                {{ requestor.phone }}
                            </p>
                        </v-col>
                        <v-col>
                            <p class="overline my-0">
                                Email
                            </p>
                            <p class="body-1 my-0">
                                {{ requestor.email }}
                            </p>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <p class="overline my-0">
                                Reason for payment
                            </p>
                            <p class="body-1">
                                {{ request.payment_request_purpose }}
                            </p>
                        </v-col>
                        <v-col class="note-row">
                            <p class="overline my-0">
                                Note/memo
                            </p>
                            <p class="body-1">
                                {{ request.note }}
                            </p>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="pa-6">
                    <v-spacer />
                    <v-btn
                        class="px-6"
                        text
                        color="red darken-2"
                        large
                        @click="show = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        class="px-6"
                        color="primary"
                        dark
                        depressed
                        large
                        @click="accept"
                    >
                        Accept
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    /* eslint-disable vue/name-property-casing */
    export default {
        name: 'request-details-modal',
        props: {
            value: {
                type: Boolean,
                required: true,
            },
            request: {
                type: Object,
                required: true,
            },
        },
        data: () => ({
            recipient: {},
        }),
        computed: {
            show: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                },
            },
            requestor() {
                return this.request.user || {};
            },
        },
        methods: {
            accept() {
                this.$emit('accept');
                this.show = false;
            },
        },
    };
</script>

<style scoped>
.w-400 {
    width: 400px;
}

.note-row {
    max-height: 100px;
    overflow-y: scroll;
}

.v-image {
    margin: auto;
}

.overline {
    line-height: 1rem;
}
</style>
